export const isFullStatic = false
export const staticPath = "/app/.nuxt/static-json"
export const publicPath = "https://static.catalog.staging.coursedog.com/f4442f3/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"